import { BaseEntity } from "yt-ng-framework";

export class KomitentUgovorStavkaView extends BaseEntity{
    constructor(){
        super();
    }

    UgovorenaVrednost: number = null;
    ValutaUgovorenaVrednost: string = null;
    UgovorenaCena: number = null;
    UgovorenaKolicina: number = null;
    UgovorenaJedinicaMere: string = null;
    CenaDodatnogPosla: number = null;
    CenaDodatnogPoslaValuta: string = null;
    Opis: string = null;

    Deserialize(input:any){
        this.ID = input.ID;
        this.UgovorenaVrednost = input.UgovorenaVrednost;
        this.ValutaUgovorenaVrednost = input.ValutaUgovorenaVrednost;
        this.UgovorenaCena = input.UgovorenaCena;
        this.UgovorenaKolicina = input.UgovorenaKolicina;
        this.UgovorenaJedinicaMere = input.UgovorenaJedinicaMere;
        this.CenaDodatnogPosla = input.CenaDodatnogPosla;
        this.CenaDodatnogPoslaValuta = input.CenaDodatnogPoslaValuta;
        this.Opis = input.Opis;
        return this;
    }

    Serialize(input: KomitentUgovorStavkaView) {
        return input;
    }
}